import { get } from 'lodash-es';
import createCachedSelector from 're-reselect';

import { emptyArray, emptyObject } from 'ui-components/default-props/empty';

export const selectLastAddedJobId = (state) => get(state, 'lastAddedJobId', '');
export const selectBulkCancelJobsByPusherJobGuid = createCachedSelector(
  (state) => get(state, 'jobIdtoJobMap', emptyObject),
  (_, { pusherJobGuid }) => pusherJobGuid,
  (jobIdtoJobMap, pusherJobGuid) => {
    const pusherJobs = Object.keys(jobIdtoJobMap)
      .map((key) => jobIdtoJobMap[key])
      .filter((job) => get(job, 'pusherJobGuids', emptyArray).indexOf(pusherJobGuid) !== -1);

    return pusherJobs.length === 0 ? emptyArray : pusherJobs;
  },
)((_, { pusherJobGuid }) => pusherJobGuid);
